import { computed } from '@vue/reactivity'
import { usePage } from '@inertiajs/vue3'
import { SharedProps, RequestProp } from '@/scripts/types/page-props'

export function useQuery() {
    const props = computed(() => usePage<{ props: SharedProps }>().props)
    const request = computed(() => props.value.request as RequestProp)
    const query = computed(() => request.value.query ?? {})
    const has = (key: string): boolean => Object.prototype.hasOwnProperty.call(query.value, key)

    return { query, has }
}
